import * as d3 from 'd3'
export default {
  
  methods: {

    setDefaultValues(){

      this.rawData = JSON.parse(JSON.stringify(this.DataItems))
      let sql1 = this.Queries.SQL1[0] 

      let json = JSON.parse(JSON.stringify(this.JQueries))
      this.title    = json.title
      this.refs     = json.refs
      this.legends  = json.legends
      this.stage    = json.stage

      this.keys     = json.keys
      this.filters  = json.filters
      this.sundries  = json.sundries
      
      // Timeline
      this.timeline = {
        ...json.timeline,
        cutoff    : sql1.CUTOFF,
        weekEnd   : this.refs.weekend,
        refColumn : this.refs.date,
      }

      // Skyline
      this.skyline = {
        ...json.skyline,
        source: sql1.TITLE_SUB,
        refColumn: this.refs.sky
      }

      // Filtering Data
      this.filteredData = this.rawData.filter(f => f[this.timeline.refColumn])
      this.set_SkylineData(this.filteredData) // ---> below

      //
      let sum_ = 0
      this.timeline.week.forEach((w, i) => {
        let periodData = this.filteredData.filter(f => f.cDate == w.eDate)
        let date_ = new Date(w.date)
        w.year = date_.getFullYear()
        w.month = date_.getMonth() + 1
        w.col = Math.ceil(periodData.length / this.skyline.maxBox) > 0 ? Math.ceil(periodData.length / this.skyline.maxBox) : 1

        sum_ += w.col
        w.sum = sum_
      })
    },


    set_SkylineData(filteredData) {
      this.gmx_SkylineValues_Week(filteredData)

      filteredData.forEach(d=> {
        let date_  = this.gmx_setTimelineCDate(d[this.timeline.refColumn])

        
        d.cDate   = date_.eDate
        d.sDate   = date_.sDate
        d.date    = d3.timeParse('%Y-%m-%d')(d[this.timeline.refColumn])
        d.tSize   = this.skyline.tSize

        this.stage.forEach(stg=> {
          if(d[this.refs.status] == stg.value) {
            d.bColor  = stg.color
            d.opacity = stg.opacity
            d.stroke  = stg.stroke 
            d.sWidth  = stg.sWidth 
            d.proRef  = stg.proRef 
          }
        })
        
      })

    },


  }
}